import * as ko from "knockout";
import type {TBaseOrObservableType} from "../../../index";
import securityHtml from "./security.html?raw";

export let template: string = securityHtml;

interface ISecurityParams {
    readOnly: boolean
    wantAssertionSigned: TBaseOrObservableType<boolean>
    wantResponseSigned: TBaseOrObservableType<boolean>
    clockSkew: TBaseOrObservableType<string | number>
}

export class viewModel {
    readonly readOnly: boolean;
    readonly wantAssertionSigned: TBaseOrObservableType<boolean>;
    readonly wantResponseSigned: TBaseOrObservableType<boolean>;
    readonly clockSkew: TBaseOrObservableType<string | number>;

    constructor(params: ISecurityParams) {
        this.readOnly = params.readOnly;
        this.wantAssertionSigned = params.wantAssertionSigned;
        this.wantResponseSigned = params.wantResponseSigned;
        this.clockSkew = params.clockSkew;
    }

    isOn = (value: TBaseOrObservableType<boolean>): boolean => !!ko.unwrap(value);
}
